import { memo, useCallback } from "react";

import { useCart } from "@shopify/hydrogen-react";

import { useCartActiveProduct } from "@cart/CartActiveProductContext";
import { CartGiftNoteStatusView } from "@cart/CartGiftNoteStatus/CartGiftNoteStatus.view";

const CartGiftNoteStatusBase = () => {
  const { toggleCartDrawer } = useCartActiveProduct();
  const { note } = useCart();

  const handleOpenGiftNoteDrawer = useCallback(() => {
    toggleCartDrawer({
      giftNoteDrawerOpen: true,
    });
  }, [toggleCartDrawer]);

  return (
    <CartGiftNoteStatusView
      handleOpenGiftNoteDrawer={handleOpenGiftNoteDrawer}
      hasPreviouslySavedGiftNote={!!note}
    />
  );
};

export const CartGiftNoteStatus = memo(CartGiftNoteStatusBase);
